import React from 'react';
import queryString from 'query-string';
import {connect} from 'react-redux';
import {API_TASK_ASSIGN_POST_SUCCESS} from 'common/types';
import ApiActions from 'go/actions/api';
import {
  HOME,
  TASK_LIST_PAGE,
} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {Container, Loader, Header} from 'semantic-ui-react';
import {Grid} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import TaskFilter from './taskList/TaskFilter';
import TaskResults from './taskList/TaskResults';
import {Alert} from 'componentLibrary';
import camundaTaskVars from 'app-ui-componentlibrary/dist/go/components/common/workflow/camundaTaskVars';
import _ from 'lodash';
import {Redirect} from 'react-router-dom';
import {
  filterExcludedRolesFromPermissions,
  getUserEntitiesForEntityType,
} from 'common/utils';
import {API_TASK_UNASSIGN_SUCCESS} from 'common/types';
import {ENTITY_MAP, EXCLUDED_ROLES} from 'app-ui-componentlibrary/dist/common/constants';
import REGION_OPTIONS from './taskList/regions';
import REST from 'go/requests/rest';

const CLEAR_FILTERS = {
  grantId: '',
  subGrantId: '',
  organizationState: '',
  assignee: '',
  fundingOpportunityNumber: '',
  fundingOpportunityId: '',
  organizationName: '',
  subOrganizationName: '',
  phase: '',
  name: '',
  region: '',
  followUpRequired: '',
  createdAfter: '',
  createdBefore: '',
};

const PRIORITY = 'priority';
const CREATED = 'created';

const CLEAR_SORT = {
  sortBy: PRIORITY,
  sortOrder: 'asc',
};

export class TaskList extends React.Component {
  constructor(props) {
    super(props);
    const query = queryString.parse(_.get(this.props, 'location.search'));
    const taskName = query.taskName;
    this.state = {
      taskName: taskName,
      filterSet: 0,
      comments: [],
      loading: true,
      error: false,
      maxResults: 25,
      firstResult: 0,
      filters: this.transformFilters(CLEAR_FILTERS),
      filtersAsEntered: CLEAR_FILTERS,
      sortOptions: CLEAR_SORT,
      results: [],
      assigneeList: [],
      userObjs: [],
      fundingOpps: [],
    };
  }

  componentDidMount() {
    document.title = this.state.taskName
      ? `${HOME} - ${this.state.taskName}`
      : TASK_LIST_PAGE;
    this.fetchMoreData();
    this.fetchAssignedTo();
    const userPrograms = getUserEntitiesForEntityType(
      this.props.permissions,
      ENTITY_MAP.PROGRAM.code
    );
    _.each(userPrograms, this.getFundingOpportunitiesForProgram);
    const filtersRetrieved = this.getStoredFilters('myTaskFilters');
    const sortOptionsRetrieved = this.getStoredFilters('myTaskSortOptions');
    if (filtersRetrieved) {
      this.onFilterChangeHelper(
        filtersRetrieved,
        this.transformFilters(filtersRetrieved),
        false
      );
    }
    if (sortOptionsRetrieved) {
      this.setSort(sortOptionsRetrieved);
    }
  }

  getStoredFilters = (key) => {
    const {id} = this.props;
    const filter = JSON.parse(localStorage.getItem(key)) || {};
    if (filter) {
      if (filter.userId !== id) {
        localStorage.setItem(key, JSON.stringify({}));
      } else return filter;
    }
    return null;
  };

  getFundingOpportunitiesForProgram = (programId) => {
    REST.fundingOpportunity
      .getFundingOpportunitiesForProgram(this.props.token, programId)
      .then((response) => response.json())
      .then((resJson) => {
        const parsedJson = JSON.parse(resJson.payload);

        this.setState({
          fundingOpps: this.state.fundingOpps.concat(parsedJson.fundingOpportunities),
        });
      })
      .catch((error) => {
        console.error('error');
      });
  };

  fetchAssignedTo() {
    //pass in the taskDefinitionKey to the API only when found in the request
    let queryParamString = this.props.location.search;
    let queryParam = queryString.parse(queryParamString);
    let taskDefKeyFound = _.has(queryParam, 'taskDefinitionKey');

    REST.workflow
      .getAssignedTo(this.props.token, taskDefKeyFound ? queryParamString : '')
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        this.setState(
          {
            assigneeList: resJson,
          },
          () => {
            const notNull = _.filter(resJson, (userId) => userId !== null);
            this.getRoles(notNull);
          }
        );
      })
      .catch((error) => {
        console.error('error');
      });
  }

  getRoles = (userListinput) => {
    const fetchBody = {
      userId: [],
    };
    let count = 0;
    for (var user in userListinput) {
      if (count == 0) {
        fetchBody.userId.push(userListinput[user]);
        count++;
      } else {
        fetchBody.userId.push(userListinput[user]);
      }
    }
    if (fetchBody.userId.length !== 0) {
      REST.user
        .getProfilesForUsers(this.props.token, fetchBody)
        .then(REST.handler.handleResponse)
        .then((data) => {
          this.setState({
            userObjs: data,
          });
        })
        .catch((error) => {
          console.error('error');
        });
    }
  };

  startTaskHandler = (id) => {
    let {assignTask, token} = this.props;
    assignTask(id, token).then((res) => {
      if (res && res.type === API_TASK_ASSIGN_POST_SUCCESS) {
        this.setState({taskId: id});
      }
    });
  };

  unassignTaskHandler = (id) => {
    const {unassignTask, token} = this.props;
    unassignTask(id, token).then((res) => {
      if (res && res.type === API_TASK_UNASSIGN_SUCCESS) {
        let data = this.state.results;
        let taskToUpdate = data[_.findIndex(data, {id})];
        taskToUpdate.assignee = null;
        this.setState({
          results: data,
          key: this.state.key + 1,
        });
      }
    });
  };

  onFilterChange = (filters) => {
    const transformedFilters = this.transformFilters(filters);
    this.onFilterChangeHelper(filters, transformedFilters);
  };

  onFilterClear = () => {
    const transformedFilters = this.transformFilters(CLEAR_FILTERS);
    this.onFilterChangeHelper(CLEAR_FILTERS, transformedFilters);
  };

  onFilterChangeHelper = (filters, transformedFilters, resetSort) => {
    const {id} = this.props;
    this.setState(
      {
        firstResult: 0,
        filtersAsEntered: filters,
        filters: transformedFilters,
        results: [],
        loading: true,
        filterSet: this.state.filterSet + 1,
        sortOptions: resetSort ? CLEAR_SORT : this.state.sortOptions,
      },
      this.fetchMoreData
    );
    localStorage.setItem(
      'myTaskFilters',
      JSON.stringify({...transformedFilters, userId: id})
    );
  };

  transformFilters = (filters) => {
    const transformedFilters = {};
    _.forEach(filters, (value, name) => {
      if (name === 'fundingOpportunityNumber') {
        value = _.get(
          _.find(
            _.get(this.state, 'fundingOpps', []),
            (fo) => fo.fundingOpportunityName === value
          ),
          'fundingOpportunityNr',
          value
        );
      }
      transformedFilters[name] = value;
    });
    return transformedFilters;
  };

  setSort = (sortOptions) => {
    const {id} = this.props;
    this.setState(
      {
        sortOptions,
        firstResult: 0,
        results: [],
        loading: true,
        filterSet: this.state.filterSet + 1,
      },
      this.fetchMoreData
    );
    localStorage.setItem(
      'myTaskSortOptions',
      JSON.stringify({...sortOptions, userId: id})
    );
  };

  fetchMoreData = _.debounce(
    () => {
      const {firstResult, maxResults, filters} = this.state;
      const paramsToOmit = ['taskName'];
      const parsed = _.omit(
        queryString.parse(_.get(this.props, 'location.search')),
        paramsToOmit
      );

      filters['userId'] = null;
      let fetchBody = {};

      if (filters['assignee'] == 'unassigned' || filters['assignee'] == null) {
        filters['assignee'] = null;
        fetchBody = {
          ...parsed,
          candidateGroups: filterExcludedRolesFromPermissions(
            this.props.permissions,
            EXCLUDED_ROLES
          ),
          orQueries: [{processVariables: []}],
          processVariables: [],
          sorting: [],
        };
      } else {
        fetchBody = {
          ...parsed,
          includeAssignedTasks: true,
          candidateGroups: filterExcludedRolesFromPermissions(
            this.props.permissions,
            EXCLUDED_ROLES
          ),
          orQueries: [{processVariables: []}],
          processVariables: [],
          sorting: [],
        };
      }

      const {sortOptions} = this.state;
      const {sortBy, sortOrder} = sortOptions;

      if (_.includes(camundaTaskVars, sortOptions.sortBy)) {
        fetchBody.sorting.push({
          sortBy: sortBy,
          sortOrder: sortOrder,
        });
      } else if (sortBy != null) {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: sortOrder,
          parameters: {
            variable: sortBy,
            type: 'string',
          },
        });
      }

      //Always add a sort by creation time
      if (sortBy !== PRIORITY) {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: 'asc',
          parameters: {
            variable: PRIORITY,
            type: 'string',
          },
        });
      }

      if (sortBy !== CREATED) {
        fetchBody.sorting.push({
          sortBy: CREATED,
          sortOrder: 'asc',
        });
      }

      // Handle search filters...
      Object.keys(filters).forEach((key) => {
        if (filters[key] || filters[key] === 0 || filters[key] === false) {
          if (camundaTaskVars.indexOf(key) < 0) {
            let filterValue = filters[key];
            for (let i = 0; i < REGION_OPTIONS.length; i++) {
              if (REGION_OPTIONS[i].value === filterValue) {
                filterValue = REGION_OPTIONS[i].text;
              }
            }
            if (typeof filterValue === 'string' && key != 'region') {
              fetchBody.processVariables.push({
                name: key,
                value: `%${filterValue}%`,
                operator: 'like',
              });
            } else if (
              key == 'fundingOpportunityId' &&
              _.isArray(filterValue) &&
              _.size(filterValue) > 0
            ) {
              _.forEach(filterValue, (foId) => {
                fetchBody.orQueries[0].processVariables.push({
                  name: key,
                  value: foId,
                  operator: 'eq',
                });
              });
            } else {
              fetchBody.processVariables.push({
                name: key,
                value: filterValue,
                operator: 'eq',
              });
            }
          } else {
            fetchBody[key] = filters[key];
          }
        }
      });

      const currentFilterSet = this.state.filterSet;
      REST.workflow
        .getTasksWithVariables(
          this.props.token,
          fetchBody,
          [
            'organizationId',
            'subGrantId',
            'grantId',
            'subApplication',
            'subApplicationCategoryMap',
            'subApplicationCategory',
            'subOrganizationName',
            'region',
            'fundingOpportunityId',
            'fundingOpportunityNumber',
            'organizationName',
            'priorityDisplay',
            'excludedPerformer',
          ],
          maxResults,
          firstResult
        )
        .then(REST.handler.handleResponse)
        .then((results) => {
          if (currentFilterSet === this.state.filterSet) {
            const currentResults = this.state.results ? this.state.results : [];
            this.setState({
              results: currentResults.concat(_.cloneDeep(results)),
              loading: false,
              firstResult: this.state.firstResult + results.length,
              hasMore: results.length > 0,
              key: 0,
            });
          }
        })
        .catch((error) => {
          console.error('error');
        });
    },
    250,
    {leading: true}
  );

  renderTasks = () => {
    const {results, hasMore, fundingOpps, userObjs} = this.state;
    const {userId} = this.props;
    return (
      <Grid.Column width={12}>
        {results && results.length > 0 ? (
          <TaskResults
            results={results}
            hasMore={hasMore}
            fetchMoreData={this.fetchMoreData}
            assignTask={this.startTaskHandler}
            unassignTask={this.unassignTaskHandler}
            fundingOpps={fundingOpps}
            userObjs={userObjs}
            userId={userId}
          />
        ) : (
          <Alert header="No tasks available" type="info">
            There were no tasks found that match your filter criteria.
          </Alert>
        )}
      </Grid.Column>
    );
  };

  render() {
    const {
      taskId,
      loading,
      sortOptions,
      assigneeList,
      taskNameList,
      userObjs,
      fundingOpps,
      filters,
      filtersAsEntered,
    } = this.state;
    const sortReorder = _.includes(this.props.toggles, 'disasterSiteNav');
    if (taskId) {
      return <Redirect to={`/tasks/${taskId}`} push />;
    } else {
      return (
        <Main>
          <Container fluid>
            <Header as="h1">Task List</Header>
            <Grid doubling stackable reversed="mobile" padded="vertically">
              {sortReorder && (
                <Grid.Column width={4}>
                  <TaskFilter
                    onFilterChange={this.onFilterChange}
                    onFilterClear={this.onFilterClear}
                    assigneeList={assigneeList}
                    filters={filters}
                    sortOptions={sortOptions}
                    taskNameList={taskNameList}
                    userObjs={userObjs}
                    fundingOpps={fundingOpps}
                    filtersAsEntered={filtersAsEntered}
                    toggles={this.props.toggles}
                    setSortBy={(sortBy) => {
                      this.setSort({
                        ...sortOptions,
                        sortBy,
                      });
                    }}
                    setSortOrder={(sortOrder) => {
                      this.setSort({
                        ...sortOptions,
                        sortOrder,
                      });
                    }}
                  />
                </Grid.Column>
              )}
              {loading ? (
                <Loader inline="centered" active>
                  Loading...
                </Loader>
              ) : (
                this.renderTasks()
              )}
              {!sortReorder && (
                <Grid.Column width={4}>
                  <TaskFilter
                    onFilterChange={this.onFilterChange}
                    onFilterClear={this.onFilterClear}
                    assigneeList={assigneeList}
                    filters={filters}
                    sortOptions={sortOptions}
                    taskNameList={taskNameList}
                    userObjs={userObjs}
                    fundingOpps={fundingOpps}
                    filtersAsEntered={filtersAsEntered}
                    setSortBy={(sortBy) => {
                      this.setSort({
                        ...sortOptions,
                        sortBy,
                      });
                    }}
                    setSortOrder={(sortOrder) => {
                      this.setSort({
                        ...sortOptions,
                        sortOrder,
                      });
                    }}
                  />
                </Grid.Column>
              )}
            </Grid>
          </Container>
        </Main>
      );
    }
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    retrieveComments: (token, grantId, phase) => {
      const action = ApiActions.comments.getCommentsForGrant(token, grantId, phase);
      const response = dispatch(action);
      return response;
    },
    assignTask: (id, token) => {
      const action = ApiActions.tasks.assignTask(id, token);
      const res = dispatch(action);
      return res;
    },
    unassignTask: (id, token) => {
      const action = ApiActions.tasks.unassignTask(token, id);
      const res = dispatch(action);
      return res;
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    userId: state.auth.userId,
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskList);
